export const env: any = {};

Object.keys(process.env).forEach((key) => {
  if (!key.startsWith("VUE_APP_") && key !== "BASE_URL") {
    return;
  }
  env[key] = process.env[key];
});
